module.exports = __webpack_public_path__ + "static/unsplash-hero-10fb72c1fcde1503f9486926d46ca1b6.jpg";